import React, { useEffect, useState } from "react";
import { ButtonIconPosition, ButtonProps, ButtonSize, ButtonType } from "./button.interface";

const Button = React.forwardRef(
    (
        {
            type,
            buttonType = "button",
            onClick,
            disable,
            icon,
            iconPosition = ButtonIconPosition.RIGHT,
            iconColorType,
            text,
            size,
            className,
            autoFocus,
            textClassName
        }: ButtonProps,
        ref: any
    ): JSX.Element => {
        const [buttonStyle, setButtonStyle] = useState<string>(
            type
                ? ""
                : `bg-primary-600 border-transparent text-white ${iconColorType === "fill" ? "fill-white" : "stroke-white"} hover:bg-primary-800 disabled:bg-[#FBFBFB] disabled:text-gray-300  ${iconColorType === "fill" ? "disabled:fill-gray-300" : "disabled:stroke-gray-300"}`
        );
        const [buttonSizeStyle, setButtonSizeStyle] = useState<string>(size ? "" : "h-[50px] px-4");
        const [loading, setLoading] = useState<boolean>(false);

        useEffect(() => {
            if (type === ButtonType.PRIMARY) {
                setButtonStyle(
                    `bg-primary-600 border-transparent text-white ${iconColorType === "fill" ? "fill-white" : "stroke-white"}  hover:bg-primary-800 disabled:bg-[#FBFBFB] disabled:text-gray-300 ${iconColorType === "fill" ? "disabled:fill-gray-300" : "disabled:stroke-gray-300"}`
                );
            } else if (type === ButtonType.SECONDARY) {
                setButtonStyle(
                    `bg-transparent border-primary-600 ${iconColorType === "fill" ? "fill-primary-600" : "stroke-primary-600"} text-primary-600 hover:bg-primary-50 hover:border-primary-800 hover:text-primary-800 ${iconColorType === "fill" ? "hover:fill-primary-800" : "hover:stroke-primary-800"} disabled:text-gray-300 ${iconColorType === "fill" ? "disabled:fill-gray-300" : "disabled:stroke-gray-300"} disabled:border-gray-300`
                );
            } else if (type === ButtonType.TERTIARY) {
                setButtonStyle(
                    `bg-transparent border-transparent ${iconColorType === "fill" ? "fill-secondary-800" : "stroke-secondary-800"} text-secondary-800 border-secondary-300 hover:border-[#A0A3BD] hover:text-secondary-800 ${iconColorType === "fill" ? "hover:fill-secondary-800" : "hover:stroke-secondary-800"} disabled:text-gray-300 ${iconColorType === "fill" ? "disabled:fill-gray-300" : "disabled:stroke-gray-300"} disabled:border-gray-300`
                );
            } else if (type === ButtonType.TEXT) {
                setButtonStyle(
                    `bg-transparent border-transparent ${iconColorType === "fill" ? "fill-primary-600" : "stroke-primary-600"} text-primary-600 hover:text-primary-800  ${iconColorType === "fill" ? "hover:fill-primary-800" : "hover:stroke-primary-800"} disabled:text-gray-300 ${iconColorType === "fill" ? "disabled:fill-gray-300" : "disabled:stroke-gray-300"}`
                );
            } else if (type === ButtonType.DELETE) {
                setButtonStyle(
                    `bg-red-600 border-transparent text-white ${iconColorType === "fill" ? "fill-white" : "stroke-white"}  hover:bg-red-800 disabled:bg-[#FBFBFB] disabled:text-gray-300 ${iconColorType === "fill" ? "disabled:fill-gray-300" : "disabled:stroke-gray-300"}`
                );
            } else if (type === ButtonType.CANCEL) {
                setButtonStyle(
                    `bg-transparent border-transparent ${iconColorType === "fill" ? "fill-gray-500" : "stroke-gray-500"} text-gray-500 hover:text-gray-500  ${iconColorType === "fill" ? "hover:fill-gray-500" : "hover:stroke-gray-500"} disabled:text-gray-100 ${iconColorType === "fill" ? "disabled:fill-gray-100" : "disabled:stroke-gray-100"}`
                );
            }
        }, [type]);

        useEffect(() => {
            if (size === ButtonSize.SM) {
                setButtonSizeStyle("h-[40px] px-3");
            } else if (size === ButtonSize.MD) {
                setButtonSizeStyle("h-[50px] px-4");
            } else if (size === ButtonSize.LG) {
                setButtonSizeStyle("h-[56px] px-5");
            }
        }, [size]);

        function onCLickHandler(e: any): void {
            if (onClick) {
                const promise = onClick(e);
                setLoading(true);
                if (promise) {
                    promise.then(() => {
                        setLoading(false);
                    });
                } else {
                    setLoading(false);
                }
            }
        }

        return (
            <button
                className={`text-[15px] flex items-center justify-center border-[1.5px] border-solid rounded-[10px] transition-all outline-none
                ${buttonStyle}
                ${buttonSizeStyle}
                ${className}
            `}
                type={buttonType}
                onClick={onCLickHandler}
                disabled={loading ? true : disable}
                ref={ref}
                autoFocus={autoFocus}
            >
                <div className={`flex items-center ${text && "gap-2"}`}>
                    {icon && iconPosition === ButtonIconPosition.RIGHT && !loading && icon}
                    <span className={textClassName}>{loading ? "صبر کنید ..." : text}</span>
                    {icon && iconPosition === ButtonIconPosition.LEFT && !loading && icon}
                </div>
            </button>
        );
    }
);

export default Button;
